import { Logo } from '../../components/Logo';
import type { WrappedParticipantStats, WrappedStats } from './wrapped-model';
import { formatDecimal } from './wrapped-display-text';

export function WrappedHeader({ onBack }: { onBack: () => void }) {
  return (
    <header className="wrapped-header">
      <button className="back-button" type="button" onClick={onBack}>
        ← Zurück
      </button>
      <Logo compact />
      <span className="wrapped-header__label">LBC Wrapped</span>
    </header>
  );
}

export function WrappedHero({ stats, personal }: { stats: WrappedStats; personal: boolean }) {
  return (
    <section
      className="wrapped-hero"
      aria-label={personal ? 'Persönliche Zusammenfassung' : 'Gruppenzusammenfassung'}
    >
      <div>
        <span className="step-label">
          {personal ? 'Deine persönliche Summe' : 'Die Gruppe in Zahlen'}
        </span>
        <strong>{stats.totalDrinks}</strong>
        <span>{stats.totalDrinks === 1 ? 'Getränk insgesamt' : 'Getränke insgesamt'}</span>
      </div>
      <div className="wrapped-hero__side">
        <span>
          {stats.drinkingDays} {personal ? 'persönliche Trinktage' : 'gemeinsame Trinktage'}
        </span>
        <span>
          {formatDecimal(stats.averagePerDrinkingDay)} Getränke pro{' '}
          {personal ? 'persönlichem' : 'gemeinsamem'} Trinktag
        </span>
      </div>
    </section>
  );
}

export function WrappedStat({
  value,
  label,
  hint,
}: {
  value: string;
  label: string;
  hint: string;
}) {
  return (
    <article className="wrapped-stat">
      <strong>{value}</strong>
      <span>{label}</span>
      <small>{hint}</small>
    </article>
  );
}

export function WrappedAward({ title, description }: { title: string; description: string }) {
  return (
    <article className="wrapped-award">
      <span aria-hidden="true">✦</span>
      <div>
        <strong>{title}</strong>
        <p>{description}</p>
      </div>
    </article>
  );
}

export function WrappedRankingRow({
  stats,
  rank,
}: {
  stats: WrappedParticipantStats;
  rank: number;
}) {
  return (
    <div className="wrapped-ranking__row">
      <span className="wrapped-ranking__rank">{rank}</span>
      <span className={`avatar avatar--${stats.participant.colorKey ?? 'sky'}`}>
        {stats.participant.displayName.slice(0, 1).toUpperCase()}
      </span>
      <strong>{stats.participant.displayName}</strong>
      <span>{stats.drinks} Getränke</span>
      <small>
        {stats.drinkingDays} Trinktage · {stats.longestStreak} Tage Serie · {stats.longestBreak}{' '}
        Tage Pause
      </small>
    </div>
  );
}
